// The 15 honest states of contract section 27, in the CONTRACT.md order.
// Every data surface renders exactly one of these with a reason and a next
// action. Tone follows the CONTRACT.md "States" table: warn for Stale, Rate
// limited, the credential states and Address unverified; loss for Provider
// unavailable and Permission denied; live blue for Ready; pulsing muted dot for
// Loading and Metadata pending; neutral for the rest. Never green for unknown.

export const HONEST_STATE_VARIANTS = [
  'Loading',
  'Ready',
  'Partial',
  'Stale',
  'No evidence observed',
  'Setup required',
  'Credential unavailable',
  'Credential exhausted',
  'Rate limited',
  'Provider unavailable',
  'Metadata pending',
  'Metadata unavailable',
  'Address unverified',
  'Authentication required',
  'Permission denied',
] as const;

export type HonestStateVariant = (typeof HONEST_STATE_VARIANTS)[number];

export type HonestTone = 'live' | 'neutral' | 'warn' | 'loss' | 'pulse';

const TONES: Readonly<Record<HonestStateVariant, HonestTone>> = {
  Loading: 'pulse',
  Ready: 'live',
  Partial: 'neutral',
  Stale: 'warn',
  'No evidence observed': 'neutral',
  'Setup required': 'neutral',
  'Credential unavailable': 'warn',
  'Credential exhausted': 'warn',
  'Rate limited': 'warn',
  'Provider unavailable': 'loss',
  'Metadata pending': 'pulse',
  'Metadata unavailable': 'neutral',
  'Address unverified': 'warn',
  'Authentication required': 'neutral',
  'Permission denied': 'loss',
};

export function toneOf(variant: HonestStateVariant): HonestTone {
  return TONES[variant];
}

export function isHonestStateVariant(value: string): value is HonestStateVariant {
  return (HONEST_STATE_VARIANTS as readonly string[]).includes(value);
}
